import { render, staticRenderFns } from "./StaffHoursForm.vue?vue&type=template&id=5810f6a6&"
import script from "./StaffHoursForm.vue?vue&type=script&lang=js&"
export * from "./StaffHoursForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports